module.exports = __webpack_public_path__ + "static/media/1-F-1.9a2d88f5.webp";